export default __webpack_public_path__ + "static/media/ic-print.cdbfceb8.svg";